export default __webpack_public_path__ + "static/media/add-file.icon.aba84c60.svg";